import { createSlice } from "@reduxjs/toolkit";
import { getCreditHistoryAction, transactionHistoryAction } from "../../actions";

interface IDashboardState {
  transactionHistoryDataLoading: boolean;
  transactionHistoryData: any;
  transactionHistoryPagination: any;
  creditHistoryDataLoading: boolean;
  creditHistoryData: any;
}

const initialState: IDashboardState = {
  transactionHistoryDataLoading: false,
  transactionHistoryData: null,
  transactionHistoryPagination: null,
  creditHistoryDataLoading: false,
  creditHistoryData: null,
}

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    //get transaction history
    builder.addCase(transactionHistoryAction.pending, (state) => {
      state.transactionHistoryDataLoading = true;
      state.transactionHistoryData = null;
      state.transactionHistoryPagination = null;
    });
    builder.addCase(transactionHistoryAction.fulfilled, (state, action) => {
      state.transactionHistoryDataLoading = false;
      state.transactionHistoryData = action.payload?.data?.transactions;
      state.transactionHistoryPagination = action.payload?.data?.pagination;
    });
    builder.addCase(transactionHistoryAction.rejected, (state) => {
      state.transactionHistoryDataLoading = false;
      state.transactionHistoryData = null;
      state.transactionHistoryPagination = null;
    });

    //get credit history
    builder.addCase(getCreditHistoryAction.pending, (state) => {
      state.creditHistoryDataLoading = true;
      state.creditHistoryData = null;
    });
    builder.addCase(getCreditHistoryAction.fulfilled, (state, action) => {
      state.creditHistoryDataLoading = false;
      state.creditHistoryData = action.payload.data;
    });
    builder.addCase(getCreditHistoryAction.rejected, (state) => {
      state.creditHistoryDataLoading = false;
      state.creditHistoryData = null;
    });
  }
})

export default historySlice.reducer;